/**
 * Convert euro cents to euros, rounded to 3 decimal places for display.
 */
export const eurCentsToEur = (cents) => parseFloat((cents / 100).toFixed(3));
/**
 * Volume consumed from a storage cylinder in litres.
 * The pressure difference is ceiled to guard against floating-point artefacts,
 * matching the server-side calculation exactly.
 */
export const calculateVolumeLitres = (cylinderVolume, startPressure, endPressure) => Math.ceil(startPressure - endPressure) * cylinderVolume;
/**
 * Raw cost of a single regular gas fill in euro cents (not rounded).
 * Sum costs from multiple rows before rounding with calcTotalFillCostCents.
 */
export const calcGasFillCostCents = (volumeLitres, pricePerLitreCents) => volumeLitres * pricePerLitreCents;
/**
 * Cost of a diluent fill in euro cents, rounded up to the nearest cent.
 * Formula: ceil((hePct / 100) * hePriceCents * volumeLitres)
 *
 * toFixed(10) strips floating-point noise (e.g. 0.4*6*100 = 240.00000000000003)
 * before ceiling, matching the result of MariaDB DECIMAL arithmetic.
 */
export const calcDiluentFillCostCents = (volumeLitres, hePct, hePriceCents) => {
    const raw = (hePct / 100) * hePriceCents * volumeLitres;
    return Math.ceil(parseFloat(raw.toFixed(10)));
};
/**
 * Total fill cost in whole euro cents.
 * All individual costs are summed first, then ceiled once to minimise rounding errors.
 */
export const calcTotalFillCostCents = (gasCostsCents, diluentCostsCents) => Math.ceil(gasCostsCents.reduce((a, b) => a + b, 0) +
    diluentCostsCents.reduce((a, b) => a + b, 0));
/**
 * Sum of prices for events that occurred after the last completed payment.
 * If no completed payment exists, returns the sum of all event prices.
 */
export const computeOpenBalance = (events, lastCompletedPaymentAt) => {
    if (!lastCompletedPaymentAt) {
        return events.reduce((sum, e) => sum + e.price, 0);
    }
    const cutoff = new Date(lastCompletedPaymentAt);
    return events
        .filter((e) => new Date(e.createdAt) > cutoff)
        .reduce((sum, e) => sum + e.price, 0);
};
